module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_intro",
    attrs: {
      "epub:type": "introduction",
      "role": "doc-introduction"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak",
      "title": "15"
    }
  }), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("W")]), _vm._v("e have longed for racial justice, built on reconciled relationships, for years. We believe that healing people and nations is the need of the hour. We began our ministry together on the college campuses of urban Chicago in the late 1980s. We taught together about reconciliation and justice. Then we prayed for people in our multiethnic gatherings and conferences. We prayed in the power of the Spirit, trusting God to heal people and to begin to heal our city, and we saw God work in some amazing ways. That citywide urban campus ministry was the beginning for us of a journey toward peace with justice.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We have both experienced the power of reconciled relationships. Our lives would be quite different if we had stayed within our own ethnic circles. We appreciate a breadth of music, culture, art, relational approaches, worship styles and social perspectives that have enriched our lives immeasurably.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We have also experienced the pain of racial division and too many "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak",
      "title": "16"
    }
  }), _vm._v("superficial and unsatisfying attempts to bridge the racial divide. Well-meaning people, including the two of us at points, have hurt others unintentionally. We have learned it is no easy thing to be reconciled and to work together for peace with justice. White people like Rick often want relationships but not justice, because justice involves painful social change. African Americans and other people of color, like Brenda, have become very tired of superficial relationships that don’t lead to social change. Some people of color have even despaired and don’t want to engage in the hard work of reconciled relationships until they have proof that those relationships will seek more than just warm feelings. In this book we want to get beyond the impasse. We seek peace with justice, and nothing less.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We have had victories in our work for peace with justice, and we have had discouraging defeats; you will read about both in the chapters to come. Through it all, we have experienced that God is powerfully at work in our day to heal people and nations. We have begun to see how God can bring social change through soul change, in individuals, communities and even nations.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("We invite you to join us in this quest to see what God is doing in our day and to join the Holy Spirit in the work of bringing peace with justice to a divided nation and world.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3037a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/pre5.vue
// module id = 75
// module chunks = 0